import {
  GET_COLECCION_DESEMBOLSO_CUENTA_EGRESO,
} from '../../shared/constants/ActionTypes';

const initialState = {
  rows: [],
  ligera: [],
  selectedRow: null,
  desde: 1,
  hasta: 1,
  por_pagina: 1,
  pagina_actual: 1,
  ultima_pagina: 1,
  total: 1,
};

const DesembolsosCuentasEgresosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COLECCION_DESEMBOLSO_CUENTA_EGRESO:
      return {
        ...state,
        ligera: action.payload.data,
      };
   
    default:
      return state;
  }
};
export default DesembolsosCuentasEgresosReducer;
